<template>
  <!-- 应用类型 -->

    <div class="applicationtype">
       <div class="con">
           <div class="Files-top">
                    <div class="ic-left">
                    <span>应用类型</span>
                    </div>
                    <div class="btns">
                      <el-button type="primary" @click="add_ed(0)" class="last-el-button">新增</el-button>
                    </div>
          </div>
           <div class="search-input-btn" style="width:100%">
                <div class="input-small">
                <span>名称：</span>
                   <el-input v-model="searchName" clearable placeholder="请输入名称"></el-input>
                </div>
                <el-button type="primary" plain @click="search_fn" class="search-btn">查询</el-button>
				   	</div>
            <div class="mytable">
                <el-table id="demo" :height="heights"
                  stripe :data="tableData"  style="width: 100%" row-key="id"
                  v-loading='isMask'>
                  <template slot="empty">
                    <span class="noData">
                      <img src="@/assets/noData.png" alt="暂无数据">
                      <span class="text">暂无数据</span>
                    </span>
                  </template>
                  <el-table-column type="index" label="序号" width="90" align="center">
                  </el-table-column>
                  <el-table-column label="名称" align="left" min-width="150">
                    <template slot-scope="{row}">
                      {{ row.name }}
                    </template>
                  </el-table-column>
                  <el-table-column v-for="(item,index) in columns" :key='index' :prop="item.key" :label="item.name"
                     :minWidth="item.width">
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="310">
                    <template #default="{row}">
                       <div class="public-flex">
                            <div @click="edit_ed(row)" class="mr-20">
                              <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                                <elIconBtn btnType='edit'></elIconBtn>
                              </el-tooltip>
                            </div>
                            <div @click="delete_fn(row)">
                              <el-tooltip class="item" effect="dark" content="删除" placement="top">
                                <elIconBtn btnType='del'></elIconBtn>
                              </el-tooltip>
                            </div>
                        </div>
                    </template>
                  </el-table-column>
                </el-table>
            </div>
               <!-- 详情 -->
                <el-dialog title="详情" v-dialogDrag :visible.sync="detail_status"  center>
                   <div style="display: flex;" class="mydialog">
                        <el-form :model="temp" ref="temp" :rules="rules" style="width: 100%;height: 120px;padding-top: 10px;">
                          <el-form-item style="margin: 0;" label="父id:">
                          <span>{{temp.EnergyTypeParentId}}</span>
                        </el-form-item>
                    </el-form>
                  </div>
                  <template #footer>
                    <span class="dialog-footer">
                      <el-button type="primary" @click="detail_status = false">确 定
                      </el-button>
                    </span>
                  </template>
                </el-dialog>

                <!-- 新增修改 -->
                <el-dialog :title="textMap[dialogStatus]" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible"
                   center>
                   <div style="display: flex;" class="mydialog">
                         <el-form :model="temp" :rules="rules" ref="temp"  class="demo-temp">
                          <el-form-item label="类型名称:" prop="name">
                            <el-input v-model="temp.name"></el-input>
                          </el-form-item>
                        </el-form>
                  </div>
                  <template #footer>
                    <span class="dialog-footer">
                      <el-button @click="dialogVisible = false">取 消</el-button>
                      <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
                      </el-button>
                    </span>
                  </template>
                </el-dialog>
       </div>
    </div>
</template>
<script>

  //   import htmlToPdf from '@/vendor/htmlToPdf';
  import {getAllEnergyType,getAllTypeByGroup,getAppTypeByGroupId,saveEnergyType,deleteEnergyType} from "../../api/energySubType";
  import {findAllAppType,apptypeSave,apptypeDeleteById} from "../../api/application";
  import resourcesStore from '@/cache/resourcesStore.js'
      import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    components: {elIconBtn},
    data () {
      return {
        tableData1:[],
        isMask: false,//遮罩层
        loading: true,
        searchName: "",//搜索名称
        total: 0,
        topLevel: 0,
        detail_status: false,
        Password: '',
        temp: {},
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },
        heights: document.getElementById('app').clientHeight-250,
        tableData: [],
        tableDataCopy: [],
        optionsd: {},
        defaultProps: {
          children: "next",
          label: "name"
        },
        dialogVisible: false,
        rules: {
          name: [
            {required: true,message: '请输入类型名称',trigger: 'blur'}
          ],
        },
        options: [],
        typeOptions: [],
        listData: {
          "Page": 1,
          "Rows": 10
        },

        columns: [
          {
            name: "编码",
            // key: "Code",
            key: "no",
            width: 90,
            al: 'center'
          },{
            name: "类型",
            // key: "Coefficient",
            key: "entityName",
            width: 90,
            al: 'center'
          }
        ],
      };
    },
    computed: {
      getResourcesByName () {
        return resourcesStore.getters.getResourcesByName
      },
    },
    watch: {
      'temp.appType': function(val) {
        // console.log("askdbhk",val);
        if(val==''||!val) {
          this.typeOptions=[]
          return
        }

        getAppTypeByGroupId({'groupId': val}).then(res => {
          // console.log(res);
          if(res.code==200) {
            this.typeOptions=res.data
          }
        })
      },
      dialogVisible: function(val) {
        // console.log(val);
        if(!val) {
          this.temp={}
        }
      },
      searchName (val) {
        if(val=='') {
          this.loading=true
          setTimeout(() => {
            this.loading=false
          },1000);
          this.deviceTableData=this.deviceTableDataCopy
        }
      },
    },
    mounted () {
      //应用类型编码
      getAllTypeByGroup().then(res => {
        //  console.log("res应用类型",res);
        this.options=res.data;
        this.getList();//获取列表数据 
      })

    },
    methods: {
      //搜索列表
      search_fn () {
        this.loading=true
        setTimeout(() => {
          this.loading=false
        },1000);
        this.tableData=this.tableDataCopy.filter((item) => item.name.includes(this.searchName));
      },

      //详情
      detail (v) {
        this.temp=v;
        this.detail_status=true;
      },
      // 删除管理员
      delete_fn (v) {
          this.$confirm(`是否删除 ${v.name}`,'提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        // console.log(v);
        apptypeDeleteById({'no': v.no}).then(res => {
          if(res.code==200) {
            this.$message({showClose: true,message: '删除成功',type: 'success'});
            this.getList();
          } else {
            this.$message.error(`删除失败，${res.message}`);
          }
        })
        }).catch(() => {
          // ...
        });
        
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            this.temp.uid=null
            apptypeSave(this.temp).then(data => {
              if(data.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '添加成功',type: 'success'});
              } else {
                this.$message.error(`添加失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },
      // 添加弹窗
      add_ed (v,l) {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.topLevel=v
        // console.log(v);
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        // this.temp = { EnergyTypeParentId: v || null};
      },
      // 确认编辑
      edit_fn (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            // console.log("this.temp",this.temp);
            // this.temp.uid = this.temp.no
            var d={
              "name": this.temp.name,
              "uid": this.temp.no,
            }
            apptypeSave(d).then(data => {
              // console.log(data);
              if(data.code==200) {
                this.getList();
                this.temp={}
                this.dialogVisible=false;
                this.$message({showClose: true,message: '修改成功',type: 'success'});
              } else {
                this.$message.error(`修改失败，${data.message}`);
              }
            })
          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.dialogStatus='edit';
        this.temp=Object.assign({},v);
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });

      },


      //获取列表数据
      getList () {
        this.isMask=true
        findAllAppType().then(res => {
          // console.log("应用类型",res);
          if(res.code==200) {
            this.tableData=res.data
            this.tableDataCopy=res.data
            this.isMask=false;
          }
        })
      },


    }
  };
</script>

<style lang="scss" scoped>
  .applicationtype {
      .con {
         width: 100%;
         height: 100%;
         padding: 12px 20px;
         box-sizing: border-box;
         background-color: #fff;
         
      }
        /deep/.el-dialog {
     width: 460px !important;
     
   }
   .mydialog {
        /deep/.el-input {
        width: 240px !important;
      }
   }
      .public-flex {
      display: flex;
      align-items: center;
      justify-content: center;
      }
       /deep/.el-dialog__header {
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E6E6E6;

      span {
        color: #67A3ED;
        font-size: 14px;
        font-weight: bold;
      }

      .el-icon-close {
        font-size: 20px !important;
      }

    }

    /deep/.el-dialog__footer {
      margin-top: 20px;
      text-align: right !important;
      border-top: 1px solid #E6E6E6;

      button {
        padding: 8px 17px;
      }
    }

   

    /deep/.el-form-item {
      display: flex;
      margin-left: 20px;
    }

    /deep/.el-form-item__label {
      white-space: nowrap;
      width: 86px;
    }

    /deep/.el-dialog__body {
      padding: 20px 0px 0px 20px !important;
    }

  }
</style>